import { useTranslation } from "react-i18next";
import { postData } from "../../../../../backend/api";
import { ToggleContainer, ToggleInput, ToggleSlider } from "../../../../elements/list/styles";
import { Logout, Popbar } from "../header/styels";
import { clearLogin, udpateLogin } from "../../../../../store/actions/login";
import { useDispatch } from "react-redux";
import { generateThumbnail } from "../../../../functions/string";
import { Bottom, ProfileIcon } from "../styels";
import { useNavigate } from "react-router-dom";
import { LogoutIcon } from "../../../../../icons";
import { LinkButton } from "../../../../styles/containers/styles";
import LanguageTooltip from "../../../../elements/tooltip";

const ProfileBar = ({ data, setLoaderBox, setMessage }) => {
  const { t } = useTranslation();
  const user = data.user;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  return (
    <Popbar className="ProfileBar">
      <ProfileIcon>{generateThumbnail(user?.fullName ?? "", null, user.photo ?? "")}</ProfileIcon>
      <span className="main">{user.fullName}</span>
      <span className="sub">{user.email}</span>
      <Bottom>
        <Logout
          onClick={() => {
            dispatch(clearLogin());
            navigate("/");
          }}
        >
          <LogoutIcon />
          {t("Signout")}
        </Logout>
      </Bottom>
      <div style={{marginTop: "20px", width: "calc(100% - 10px)"}}>
        <LanguageTooltip></LanguageTooltip>
      </div>
    </Popbar>
  );
};
export default ProfileBar;
